import { useLoginStore } from '@/stores/login'
import { Button, Form, Input, Modal, Segmented } from 'antd'
import { BorderBeam } from './magicui/border-beam'

function LoginForm() {
  const [targetDate, setTargetDate] = useState<number>()

  const [countdown] = useCountDown({ targetDate })
  const { formType, setFormType } = useLoginStore()
  const [form] = Form.useForm()

  const onFinish = (values: any) => {
    console.log(values)
  }
  return (
    <Modal
      destroyOnClose
      closeIcon={false}
      onOk={form.submit}
      title={(
        <div className="text-center">
          <Segmented
            size="large"
            value={formType}
            style={{ marginBottom: 8 }}
            onChange={setFormType}
            options={[{ value: 'login', label: '登 录' }, { value: 'signup', label: '注 册' }]}
          />
        </div>
      )}
      onCancel={() => setFormType(false)}
      open={!!formType}
    >
      <Form form={form} onFinish={onFinish} className="py-6" requiredMark={false}>
        <Form.Item<string> name="email" rules={[{ required: true, type: 'email', message: '请输入正确的邮箱' }]}>
          <Input size="large" type="text" placeholder="邮箱" />
        </Form.Item>
        {(formType === 'signup') && (
          <Form.Item<string> name="code" rules={[{ required: true, message: '请输入' }]}>
            <Input
              suffix={
                countdown > 0
                  ? (
                      <Button danger disabled size="small">
                        {Math.floor(countdown / 1000)}
                        S后重试
                      </Button>
                    )
                  : (
                      <Button danger size="small" onClick={() => setTargetDate(Date.now() + 60 * 1000)}>
                        发送
                      </Button>
                    )
              }
              size="large"
              type="password"
              placeholder="邮箱验证码"
            />
          </Form.Item>
        )}
        <Form.Item<string> name="password" rules={[{ required: true, message: '请输入' }]}>
          <Input size="large" type="password" placeholder="密码" />
        </Form.Item>
        {(formType === 'signup') && (
          <Form.Item<string> name="confirm-password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password size="large" type="password" placeholder="确认密码" />
          </Form.Item>
        )}
      </Form>

      <BorderBeam duration={8} size={100} />
    </Modal>
  )
}

export default LoginForm
